const dynamicContentItemDirectiveFactory = require('./dynamic-content-item-directive');

require('angular').module('wowApp.shop')
    .factory('DynamicContentService', ['Restangular', '$cacheFactory', require('./dynamic-content-service')])
    .service('DynamicContentCarouselService', ['SettingsService', '$templateRequest', require('./dynamic-content-carousel-service')])
    .directive('olyDcUrlSchedule', ['$location', require('./dynamic-content-url-schedule')])
    .directive('wowManageDc', ['DynamicContentService', '$window', require('./manage-dc-directive')])
    .directive('olyDynamicContent', [
        'TrolleyService',
        'ShelfProductService',
        'DynamicContentService',
        'DynamicContentCarouselService',
        'InspirationService',
        'AtmService',
        '$location',
        '$sce',
        '$compile',
        '$timeout',
        '$rootScope',
        'BreakpointsService',
        'carouselConfig',
        require('./dynamic-content-directive')
    ])
    .directive('olyDcDialog', ['DynamicContentService', 'DialogRegistry', require('./dynamic-content-dialog-directive')])
    .directive('olyDcHideViewed', ['LocalStorageService', require('./dynamic-content-hide-viewed-directive')])
    .directive('olyDcProductGroup', [require('./dynamic-content-product-group-directive')])
    .directive('olyDcProductGroupProducts', ['ProductGroupService', '$timeout', '$q', require('./dynamic-content-product-group-products-directive')])
    .directive('olyDynamicContentProduct', [dynamicContentItemDirectiveFactory('<bws-product product="item" ng-if="item"></wow-shelf-product>', 'Products')])
    .directive('olyDynamicContentRecipe', [dynamicContentItemDirectiveFactory('<wow-recipe recipe="item" ng-if="item"></wow-recipe>', 'Recipes')])
    .directive('olyDynamicContentCard', [dynamicContentItemDirectiveFactory('<wow-inspiration-card card="item" ng-if="item"></wow-inspiration-card>', 'Cards')])
    .directive('olyDynamicContentFeature', [dynamicContentItemDirectiveFactory('<bws-feature-card feature="item" ng-if="item"></bws-feature-card>', 'Features')])
    .directive('wowDynamicContentProduct', ['ShelfProductService', require('./dynamic-content-product-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/dynamiccontent/index.js
 **/